import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import "./styles/newdetail.scss";
import { backend } from "../../components/apipath";
import axios from "axios";

function Newdetail() {
  const { new_id } = useParams();
  const [detailData, setDetailData] = useState({});

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${backend}home/newdetail/${new_id}`);
        setDetailData(response.data);
      } catch (error) {
        console.error("Error fetching new detail:", error);
      }
    };
    fetchData();
  }, [new_id]);

  function cleanHTML(html) {
    if (!html) return "";
    return html.replace(/<p>(?:\s|&nbsp;| |<br\s*\/?>)*<\/p>/gi, "");
  }

  // ✅ 文章內容更新後，等 DOM 渲染完再初始化複製功能
  useEffect(() => {
    // 用 setTimeout 0，確保 dangerouslySetInnerHTML 已經進 DOM
    const t = setTimeout(() => {
      if (window.__btHolidayCopyInitAll) window.__btHolidayCopyInitAll();
      // 如果你用的是舊命名，就改成：
      // if (window.__btCopyInitAll) window.__btCopyInitAll();
    }, 0);

    return () => clearTimeout(t);
  }, [detailData]);

  return (
    <>
      <div className="container">
        <div className="tabcontent">
          {Object.values(detailData).map((item, index) => (
            <div className="mt100" key={index}>
              <div className="w-100">
                <h5 className="title mb-5">{item.title}</h5>

                <div
                  className="m-auto mb-5 article-content"
                  dangerouslySetInnerHTML={{ __html: cleanHTML(item.intro) }}
                />

                <div
                  className="m-auto mb-5 article-content"
                  dangerouslySetInnerHTML={{ __html: cleanHTML(item.content) }}
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}

export default Newdetail;
